import React from 'react';
import { HStack, Text, Icon, Box, Circle, VStack } from '@chakra-ui/react';
import { 
  FaCalendar, 
  FaClock, 
  FaRegClock,
  FaCheckCircle,
  FaRegCalendarCheck,
  FaRegCalendarAlt
} from 'react-icons/fa';
import { 
  BsCalendarCheck, 
  BsCalendarWeek,
  BsBookmark,
  BsBookmarkCheck
} from 'react-icons/bs';

const sizes = {
  small: {
    fontSize: "xl",
    iconSize: 5,
    boxSize: "20px",
    containerSize: "32px"
  },
  regular: {
    fontSize: "2xl",
    iconSize: 6,
    boxSize: "24px",
    containerSize: "40px"
  },
  large: {
    fontSize: "3xl",
    iconSize: 7,
    boxSize: "32px",
    containerSize: "48px"
  }
};

export const LogoVariant1 = ({ size = "regular" }) => {
  const sizeProps = sizes[size] || sizes.regular;

  return (
    <HStack spacing={2}>
      <Box position="relative">
        <Icon 
          as={FaRegCalendarAlt} 
          boxSize={sizeProps.iconSize} 
          color="#82ca9c" 
        />
        <Icon
          as={FaCheckCircle}
          boxSize={sizeProps.iconSize - 2}
          color="white"
          position="absolute"
          bottom="-2px"
          right="-2px"
        />
      </Box>
      <Text
        fontSize={sizeProps.fontSize}
        fontWeight="bold"
        bgGradient="linear(to-r, #82ca9c, #6eb589)"
        bgClip="text"
        letterSpacing="tight"
      >
        BirdieHouse
      </Text>
    </HStack>
  );
};

export const LogoVariant2 = ({ size = "regular" }) => {
  const sizeProps = sizes[size] || sizes.regular;

  return (
    <HStack spacing={2}>
      <Circle size={`${sizeProps.iconSize * 4}px`} bg="#82ca9c" position="relative">
        <Icon 
          as={FaClock} 
          boxSize={sizeProps.iconSize} 
          color="white"
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
        />
      </Circle>
      <Text
        fontSize={sizeProps.fontSize}
        fontWeight="black"
        color="white"
      >
        Birdie
        <Text as="span" color="#82ca9c">House</Text>
      </Text>
    </HStack>
  );
};

export const LogoVariant3 = ({ size = "regular" }) => {
  const sizeProps = sizes[size] || sizes.regular;

  return (
    <Box
      bg="#1A1824"
      px={4}
      py={2}
      borderRadius="xl"
      height={sizeProps.containerSize}
      display="flex"
      alignItems="center"
      borderWidth="1px"
      borderColor="whiteAlpha.200"
    >
      <HStack spacing={3}>
        <Box position="relative">
          <Icon 
            as={BsCalendarWeek} 
            boxSize={sizeProps.iconSize} 
            color="#82ca9c" 
          />
          <Icon
            as={BsBookmarkCheck}
            boxSize={sizeProps.iconSize - 2}
            color="white"
            position="absolute"
            top="50%"
            left="50%"
            transform="translate(-50%, -50%)"
          />
        </Box>
        <Text
          fontSize={sizeProps.fontSize}
          fontWeight="bold"
          color="white"
          letterSpacing="tight"
        >
          BirdieHouse
        </Text>
      </HStack>
    </Box>
  );
};

export const LogoVariant4 = ({ size = "regular" }) => {
  const sizeProps = sizes[size] || sizes.regular;

  return (
    <HStack spacing={3}>
      <Box 
        position="relative" 
        width={sizeProps.containerSize} 
        height={sizeProps.containerSize}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Icon
          as={FaRegCalendarCheck}
          boxSize={sizeProps.boxSize}
          color="#82ca9c"
        />
        <Box
          position="absolute"
          top="0"
          left="0"
          right="0"
          bottom="0"
          borderRadius="xl"
          border="2px solid"
          borderColor="#82ca9c"
          opacity={0.3}
        />
      </Box>
      <VStack spacing={0} align="start">
        <Text
          fontSize={sizeProps.fontSize}
          fontWeight="extrabold"
          color="white"
          lineHeight="shorter"
        >
          BIRDIE
        </Text>
        <Text
          fontSize={sizeProps.fontSize}
          fontWeight="medium"
          color="#82ca9c"
          lineHeight="shorter"
        >
          HOUSE
        </Text>
      </VStack>
    </HStack>
  );
};

const Logo = ({ variant = 1, size = "regular" }) => {
  const variants = {
    1: LogoVariant1,
    2: LogoVariant2,
    3: LogoVariant3,
    4: LogoVariant4
  };

  const SelectedVariant = variants[variant] || variants[1];
  return <SelectedVariant size={size} />;
};

export default Logo; 